/* src/app/views/import-contract/import-contract.component.scss */
.import-contract {
  padding-bottom: 24px;
}
.import-contract-section {
  width: min(1120px, 100% - 64px);
  margin: 0 auto 24px;
  padding: 24px 28px;
  background: #ffffff;
  border: 1px solid #d9dfe7;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.05);
  box-sizing: border-box;
}
.import-contract-section:last-child {
  margin-bottom: 0;
}
.import-contract h3,
.import-contract h4 {
  margin: 0;
  color: #1b2538;
  font-weight: 600;
  line-height: 1.2;
}
.import-contract h3 {
  font-size: 32px;
  margin-bottom: 12px;
}
.import-contract h4 {
  font-size: 22px;
  margin: 0 0 14px;
}
.import-contract label {
  display: inline-block;
  margin-bottom: 8px;
  color: #334155;
  font-size: 15px;
  font-weight: 500;
}
.import-contract-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  margin-bottom: 8px;
  text-align: right;
}
.btn-next {
  min-width: 190px;
  height: 48px;
  padding: 0 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}
.import-contract table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
  table-layout: auto;
}
.import-contract td {
  vertical-align: top;
  padding-right: 12px;
  color: #475569;
  font-size: 14px;
  line-height: 1.35;
}
.import-contract fieldset {
  padding: 20px;
  border: 1px solid #d9dfe7;
  border-radius: 14px;
  background: #f8fafc;
  margin: 0 0 18px;
  min-width: 0;
}
:host ::ng-deep .import-contract .p-fileupload,
:host ::ng-deep .import-contract .p-table,
:host ::ng-deep .import-contract .p-progressbar,
:host ::ng-deep .import-contract .p-inputtext,
:host ::ng-deep .import-contract .p-inputmask,
:host ::ng-deep .import-contract .p-inputnumber,
:host ::ng-deep .import-contract .p-dropdown {
  width: 100%;
  box-sizing: border-box;
}
:host ::ng-deep .import-contract .p-fileupload {
  border-radius: 14px;
  overflow: hidden;
}
:host ::ng-deep .import-contract .p-fileupload .p-fileupload-buttonbar,
:host ::ng-deep .import-contract .p-fileupload .p-fileupload-content {
  padding: 1rem 1.25rem;
}
:host ::ng-deep .import-contract .p-table .p-datatable-wrapper {
  border-radius: 12px;
  overflow: auto;
}
:host ::ng-deep .import-contract .p-inputtext,
:host ::ng-deep .import-contract .p-inputmask,
:host ::ng-deep .import-contract .p-inputnumber-input,
:host ::ng-deep .import-contract .p-dropdown {
  min-height: 48px;
  border-radius: 12px;
  border: 1px solid #c8d1dc;
  background: #ffffff;
}
:host ::ng-deep .import-contract .p-dropdown .p-dropdown-label {
  padding: 13px 16px;
  line-height: 1.2;
}
@media only screen and (max-width: 900px) {
  .import-contract-section {
    width: calc(100% - 32px);
    padding: 20px;
  }
  .import-contract h3 {
    font-size: 26px;
  }
  .import-contract h4 {
    font-size: 20px;
  }
}
@media only screen and (max-width: 700px) {
  .import-contract-section {
    padding: 16px;
  }
  .import-contract-actions {
    justify-content: stretch;
  }
  .import-contract-actions .btn-next {
    width: 100%;
  }
  .import-contract table,
  .import-contract tbody,
  .import-contract tr,
  .import-contract td {
    display: block;
  }
  .import-contract td {
    width: 100%;
    padding-right: 0;
  }
}
/*# sourceMappingURL=import-contract.component-FBWTAZO7.css.map */
